import { formatUZS } from './format';

type Priced = {
  price: string;
  oldPrice?: string | null;
  priceUzs?: string;
  oldPriceUzs?: string | null;
  meta?: { currency?: 'USD' | 'UZS' } | null;
};

export function isUsdProduct(p: Priced): boolean {
  return p.meta?.currency === 'USD';
}

/** Mahsulotning "ko'rsatiladigan" narxi: USD bo'lsa "$49", aks holda "49,000 UZS". */
export function formatProductPrice(p: Priced, field: 'price' | 'oldPrice' = 'price'): string {
  const v = field === 'price' ? p.price : p.oldPrice;
  if (v === null || v === undefined) return '—';
  if (isUsdProduct(p)) return `$${Number(v).toLocaleString('en-US')}`;
  return formatUZS(v);
}

/** Foydalanuvchi to'laydigan UZS summasi (server kursi bo'yicha). */
export function formatProductPriceUzs(p: Priced): string {
  return formatUZS(p.priceUzs ?? p.price);
}
